import { AdjustmentsProps } from "@config/types/adjustments.interface";
import { CSSProperties } from "react";

function useAdjustments() {
  const adjust = (
    props?: Partial<AdjustmentsProps>,
    easing: string = "all 0.6s cubic-bezier(0.65, 0, 0.35, 1)"
  ): CSSProperties => {
    if (!props) return {};
    return {
      transform: `
        translateX(${props.x ?? 0}px)
        translateY(${props.y ?? 0}px)
        scale(${1 + (props.scale ?? 0) * 0.01})
        scaleX(${1 * (props.flip_x ? -1 : 1)})
        scaleY(${1 * (props.flip_y ? -1 : 1)})
        `,
      fontSize: props.font_size || "",
      transition: easing,
      height: props.h !== 0 ? props.h : 200,
      width: props.w !== 0 ? props.w : 200,
    } as CSSProperties;
  };

  return adjust;
}

export default useAdjustments;
